<script setup lang="ts">
import Button from 'primevue/button'

const scrollTo = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
</script>

<template>
  <section class="relative overflow-hidden min-h-screen flex items-center justify-center px-6 md:px-12 py-24">
    <div class="absolute inset-0 pointer-events-none" aria-hidden="true">
      <div class="dandelion dandelion-1 absolute top-[12%] right-[5%] w-28 h-36 sm:w-36 sm:h-44 rotate-[-6deg]" />
      <div class="dandelion dandelion-3 absolute top-[60%] left-[4%] w-24 h-32 sm:w-32 sm:h-40 rotate-[8deg]" />
      <div
        class="dandelion dandelion-2 absolute bottom-[8%] right-[10%] w-20 h-28 sm:w-24 sm:h-32 -scale-x-100 rotate-[12deg]" />
    </div>
    <div class="relative max-w-4xl text-center flex flex-col gap-8">
      <img src="/og-image.jpg" alt="Nathalie Gottvalles, psychologue clinicienne à Javerlhac" width="1200" height="630"
        class="w-40 h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 mx-auto rounded-full object-cover object-[45%_center] border border-stone-200 dark:border-stone-800 shadow-lg" />
      <h1 class="text-5xl md:text-7xl leading-tight text-stone-900 dark:text-stone-50">Nathalie Gottvalles</h1>
      <p class="uppercase tracking-[0.3em] text-sm text-terracotta-600 dark:text-terracotta-400 font-medium">
        Psychologue clinicienne — Psychothérapeute
      </p>
      <div
        class="flex flex-col gap-5 text-stone-600 dark:text-stone-300 max-w-2xl mx-auto leading-relaxed text-lg md:text-xl">
        <p>
          Je suis psychologue depuis plus de 30 ans, j'accompagne adultes et adolescents dans des moments de
          difficulté, de questionnement ou de souffrance.
        </p>
        <p>
          J'ai travaillé plus de 10 ans en milieu hospitalier, en psychiatrie adulte ainsi qu'en pédopsychiatrie avec
          les enfants et leurs parents. J'ai développé en parallèle une activité en cabinet libéral en
          Nouvelle-Calédonie, à Bordeaux et désormais en Dordogne ainsi qu'en téléconsultation.
        </p>
      </div>
      <div class="flex flex-wrap items-center justify-center gap-4 pt-4">
        <Button label="Prendre rendez-vous" icon="pi pi-calendar" severity="primary" size="large"
          @click="scrollTo('rendez-vous')" />
        <Button label="En savoir plus" icon="pi pi-arrow-down" severity="secondary" size="large" text
          @click="scrollTo('about')" />
      </div>
    </div>
  </section>
</template>
